/**
 * Check if an element has scroll
 * @usage $("#element").hasScrollBar();
 */
(function($) {
    $.fn.hasScrollBar = function() {
        return this.get(0) ? this.get(0).scrollHeight > this.innerHeight() : false;
    };
})(jQuery);